import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface AppointmentRejectedTranslations {
  title: string;
  greeting: string;
  body: string;
  labelRequestedDate: string;
  labelRequestedTime: string;
  labelExhibitor: string;
  action: string;
  ctaText: string;
  signOff: string;
  teamSignature: string;
  layout: LayoutTranslations;
}

interface AppointmentRejectedProps {
  visitorName: string;
  exhibitorName: string;
  date: string;
  time: string;
  translations: AppointmentRejectedTranslations;
}

export default function AppointmentRejected({
  visitorName,
  exhibitorName,
  date,
  time,
  translations: tx,
}: AppointmentRejectedProps) {
  return (
    <Layout previewText={`${tx.title} - ${exhibitorName}`} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} {visitorName},</Text>
      <Text style={paragraph}>{tx.body.replace('{{name}}', exhibitorName)}</Text>

      <Section style={infoBox}>
        <Text style={infoLine}>{tx.labelRequestedDate}: {date}</Text>
        <Text style={infoLine}>{tx.labelRequestedTime}: {time}</Text>
        <Text style={infoLine}>{tx.labelExhibitor}: {exhibitorName}</Text>
      </Section>

      <Text style={paragraph}>{tx.action}</Text>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/networking" style={ctaButton}>{tx.ctaText}</Link>
      </Section>

      <Text style={paragraph}>{tx.signOff}<br />{tx.teamSignature}</Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#dc2626', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const infoBox: React.CSSProperties = { backgroundColor: '#fef2f2', borderLeft: '4px solid #ef4444', padding: '16px 20px', margin: '20px 0', borderRadius: '0 4px 4px 0' };
const infoLine: React.CSSProperties = { fontSize: '15px', color: '#991b1b', margin: '0 0 8px 0' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#2563eb', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
